import React from 'react';
import { getImageUrl } from '@wix/communities-blog-client-common';
import { Image } from '@app/external/common/components/image/image';
import { type NormalizedPost } from '@app/external/common/types';
import classes from './post-page-post-header-image.scss';

type Props = {
  post: NormalizedPost;
};

const PostPagePostHeaderImage: React.FC<Props> = (props) => {
  const image = props.post.heroImage;

  const uri = getImageUrl({
    image,
    maxHeight: 980,
    maxWidth: image?.width,
    type: 'fit',
    encoding: 'AVIF',
  });

  if (!uri) {
    return null;
  }

  return <Image image={uri} className={classes.img} displayMode="fit" />;
};

export default PostPagePostHeaderImage;
